import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom'
import { AdminShell } from './AdminShell'
import { AccountsPage } from './AccountsPage'
import { AccountDetailPage } from './AccountDetailPage'
import { ApplicationsPage } from './ApplicationsPage'
import { ApplicationDetailPage } from './ApplicationDetailPage'
import { SettingsPage } from './SettingsPage'
import { AuthErrorScreen } from './AuthErrorScreen'
import { LoginScreen } from './LoginScreen'
import { DocumentUploadPage } from './DocumentUploadPage'
import {
  AdminSessionProvider,
  RequireAdminAuth,
  RequireAdminRole,
  RedirectIfAuthed,
} from './session'

// Mounted under /admin (basename), same pattern as the applicant flow's
// ApplyApp under /apply. Google Sign-In (adminauth package) gates every route
// except /login and /auth/error, which must render without a session.
export function AdminApp() {
  return (
    <BrowserRouter basename="/admin">
      <AdminSessionProvider>
        <Routes>
          <Route path="/login" element={<RedirectIfAuthed><LoginScreen /></RedirectIfAuthed>} />
          <Route path="/auth/error" element={<AuthErrorScreen />} />
          <Route
            path="/*"
            element={
              <RequireAdminAuth>
                <AdminShell>
                  <Routes>
                    <Route path="/" element={<Navigate to="/accounts" replace />} />
                    <Route path="/accounts" element={<AccountsPage />} />
                    <Route path="/accounts/:id" element={<AccountDetailPage />} />
                    <Route path="/applications" element={<ApplicationsPage />} />
                    <Route path="/applications/:id" element={<ApplicationDetailPage />} />
                    <Route path="/settings" element={<SettingsPage />} />
                    <Route
                      path="/docai-test"
                      element={<RequireAdminRole><DocumentUploadPage /></RequireAdminRole>}
                    />
                  </Routes>
                </AdminShell>
              </RequireAdminAuth>
            }
          />
        </Routes>
      </AdminSessionProvider>
    </BrowserRouter>
  )
}
